//deps
import React, { memo } from "react";

// dls
import { SpriteIconWeb } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb";

// styles
import { CloseIconContainer } from "../styles";

//constants
import { M2C_HALFCARD_TEST_IDS } from "../constants";

const BlackCloseIcon = ({ onClick }: { onClick: VoidFunction }) => {
    return (
        <CloseIconContainer onClick={onClick} data-testid={M2C_HALFCARD_TEST_IDS.CLOSE_BUTTON}>
            <SpriteIconWeb iconName="close16" fillColor="stroke_One_Blck" strokeColor="stroke_One_Blck" />
        </CloseIconContainer>
    );
};

export default memo(BlackCloseIcon);
